const api = {
	listStations: '/station/listStations',    //站点列表
	addStation: '/station/addStation',        //添加站点
	deleteStation: '/station/deleteStation',  //删除站点
	updateStation: '/station/updateStation',  //编辑站点
};

const routes = {
	'/station-manage': '站点管理',
};

export { api, routes };
